module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "currentExercise"
  }, [_c('div', {
    staticClass: "exercise-item text-left"
  }, [(_vm.examResults) ? _c('span', {
    staticClass: "time"
  }, [(_vm.CelotnoVprasanje.correct != null && _vm.CelotnoVprasanje.correct !== 0) ? _c('span', [(_vm.CelotnoVprasanje.correct) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()]) : _c('span', {
    staticClass: "time"
  }, [(_vm.isCorrect != null) ? _c('span', {
    staticClass: "green-color"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('pages.exercise.submitEssay')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('h4', {
    staticClass: "exercise-header",
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.pickTranslation(_vm.CelotnoVprasanje.text))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "exercise-body text-left"
  }, [_c('span', {
    staticClass: "row"
  }, [(_vm.examResults) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submitInfo.selectedAnswer),
      expression: "submitInfo.selectedAnswer"
    }],
    staticClass: "form-control",
    class: [_vm.CelotnoVprasanje.correct === true ? 'correct' : '', _vm.CelotnoVprasanje.correct === false ? 'incorrect' : ''],
    attrs: {
      "disabled": "",
      "rows": "3",
      "id": "comment"
    },
    domProps: {
      "value": (_vm.submitInfo.selectedAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.submitInfo, "selectedAnswer", $event.target.value)
      }
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submitInfo.selectedAnswer),
      expression: "submitInfo.selectedAnswer"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "id": "comment"
    },
    domProps: {
      "value": (_vm.submitInfo.selectedAnswer)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.evalExercise($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.submitInfo, "selectedAnswer", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "exercise-footer"
  }, [(_vm.isExam) ? [(!_vm.examResults) ? _c('button', {
    staticClass: "btn btn-success pull-left",
    class: {
      'small-button': _vm.detectMobile() && _vm.scoringSettings && _vm.scoringSettings[_vm.CelotnoVprasanje.guid].allowNegativePointsSum
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.evalExercise($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.evaluateExam')))]) : _vm._e(), _vm._v(" "), (!_vm.examResults) ? _c('button', {
    staticClass: "btn btn-warning pull-left",
    class: {
      'small-button': _vm.detectMobile() && _vm.scoringSettings && _vm.scoringSettings[_vm.CelotnoVprasanje.guid].allowNegativePointsSum
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearExercise($event)
      }
    }
  }, [_vm._v(_vm._s((_vm.$t('pages.exercise.examClearExercise'))))]) : _vm._e(), _vm._v(" "), (_vm.examResults) ? _c('ShowSolutionExamResults', {
    attrs: {
      "examResults": _vm.examResults,
      "CelotnoVprasanje": _vm.CelotnoVprasanje,
      "nameOfTheParent": _vm.Name
    }
  }) : _vm._e(), _vm._v(" "), (_vm.examResults) ? _c('SolutionModal', {
    attrs: {
      "CelotnoVprasanje": _vm.CelotnoVprasanje,
      "solutionKeyId": _vm.solutionKey,
      "i": _vm.index,
      "identifier": _vm.identifier,
      "exerciseVersionId": _vm.exerciseVersionId,
      "parentIdentifier": _vm.parent
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.examResults) ? _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "14px"
    }
  }, [(_vm.scoringSettings) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.points')) + ": " + _vm._s(_vm.scoringSettings[_vm.CelotnoVprasanje.guid].posPoints) + "\n            "), (_vm.scoringSettings[_vm.CelotnoVprasanje.guid].allowNegativePointsSum) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.exercise.points')) + ": (-" + _vm._s(_vm.scoringSettings[_vm.CelotnoVprasanje.guid].negPoints) + ")")]) : _vm._e()]) : _vm._e()]) : (_vm.CelotnoVprasanje.points !== null && _vm.CelotnoVprasanje.maxPoints !== null) ? _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.points')) + ": " + _vm._s(_vm.CelotnoVprasanje.points) + "/" + _vm._s(_vm.CelotnoVprasanje.maxPoints) + "\n          ")])]) : _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.pointsNotAvailable')))])]), _vm._v(" "), _c('div', {
    staticClass: "vertical"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.submitted) ? _c('p', {
    staticClass: "text-green"
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.evaluated')))]) : _vm._e()])], 1)] : [_c('button', {
    staticClass: "btn btn-success pull-left",
    class: {
      'small-button': _vm.detectMobile() && _vm.CelotnoVprasanje.hasSolution
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.evalExercise($event)
      }
    }
  }, [_vm._v(_vm._s((_vm.$t('pages.exercise.evaluateEssay'))))]), _vm._v(" "), (_vm.CelotnoVprasanje.hintCount > 0) ? _c('button', {
    staticClass: "btn btn-warning text-center",
    class: {
      'small-button': _vm.detectMobile() && _vm.CelotnoVprasanje.hasSolution
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hintExercise($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.hintText')))]) : _vm._e(), _vm._v(" "), _c('SolutionModal', {
    attrs: {
      "CelotnoVprasanje": _vm.CelotnoVprasanje,
      "solutionKeyId": _vm.solutionKey,
      "i": _vm.index,
      "identifier": _vm.identifier,
      "exerciseVersionId": _vm.exerciseVersionId,
      "parentIdentifier": _vm.parent
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.submitInfo.hintNumber > 0) ? _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": _vm.hintKey
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.hintText')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.exHints), function(eHint, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.translateVhtml(eHint))
      }
    })])
  }), 0)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73accc8b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73accc8b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/types/Essay.vue
// module id = 1448
// module chunks = 1